export enum NavStates {
  LoggedOutEmptyCart = 'loggedOutEmptyCart',
  LoggedOutNonEmptyCart = 'loggedOutNonEmptyCart',
  LoggedInEmptyCart = 'loggedInEmptyCart',
  LoggedInNonEmptyCart = 'loggedInNonEmptyCart',
}

const isHomepage = (asPath: string) => asPath.split(/[?#]/)[0] === '/';

// Get Started only shows on the homepage; elsewhere logged-out empty carts see Cart.
export const getNavCtas = (navState: NavStates, asPath: string) => {
  const loggedOutEmpty = navState === NavStates.LoggedOutEmptyCart;
  const onHomepage = isHomepage(asPath);

  return {
    showGetStarted: loggedOutEmpty && onHomepage,
    showCart:
      navState === NavStates.LoggedOutNonEmptyCart ||
      navState === NavStates.LoggedInNonEmptyCart ||
      (loggedOutEmpty && !onHomepage),
  };
};

export const getNavState = (userState, userCart): NavStates => {
  const loggedIn = !!userState?.email;
  const cartEmpty = userCart.isEmpty();

  if (!loggedIn && cartEmpty) {
    return NavStates.LoggedOutEmptyCart;
  }

  if (!loggedIn && !cartEmpty) {
    return NavStates.LoggedOutNonEmptyCart;
  }

  if (loggedIn && cartEmpty) {
    return NavStates.LoggedInEmptyCart;
  }

  return NavStates.LoggedInNonEmptyCart;
};
